/* unplugin-vue-components disabled */import script from "./test.vue?vue&type=script&lang=ts&setup=true"
export * from "./test.vue?vue&type=script&lang=ts&setup=true"

import "./test.vue?vue&type=style&index=0&id=3fbc0d1a&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/vue-ddm-quiz-pc-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fbc0d1a"]])

export default __exports__